import {
  DatahubEntity,
  IDefaultSchema,
  ILoadedMetadataSchema,
  LoadedMetadataAction,
  DATA_VERSION,
  CaptureEventData,
  CaptureEvent,
} from 'src/interfaces/Datahub';
import loadedMetadataSchema from './schema';
class LoadedMetadata {
  private defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  get schema() {
    return loadedMetadataSchema;
  }

  measure(captureEvent: CaptureEvent<LoadedMetadataAction>) {
    const event: ILoadedMetadataSchema = {
      ...this.defaultData,
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['1.0'],
    };

    captureEvent(DatahubEntity.LOADEDMETADATA, LoadedMetadataAction.MEASURE, data);
  }
}
export default LoadedMetadata;
